import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { RepaymentsService } from './../../../services/repayments.service';

declare var $: any;

@Component({
  selector: 'app-repayment-by-commodity',
  templateUrl: './repayment-by-commodity.component.html',
  styleUrls: ['./repayment-by-commodity.component.css'],
})
export class RepaymentByCommodityComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  fromDate: any;
  toDate: any;
  loanDataToShow: any;
  cmdShow: boolean = true;
  whrShow: boolean;
  loanShow: boolean;
  loanAppsLoaded: Boolean = false;
  valMsgRS: Boolean = false;

  isFilterSet: boolean = false;

  constructor(private lservice: RepaymentsService) {}

  ngOnInit() {
    this.getRepaymentByCommodity();
  }

  getRepaymentByCommodity(query = {}) {
    this.dataToShow = [];
    this.loanAppsLoaded = false;

    this.lservice.RepaymentbyCommodity(query).subscribe((data) => {
      this.loanAppsLoaded = true;

      this.cmdShow = true;
      this.whrShow = false;
      this.loanShow = false;
      this.dataRec = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      }
    });
  }

  whrData(obj) {
    this.loanAppsLoaded = true;
    this.cmdShow = false;
    this.whrShow = true;
    this.loanShow = false;
    let json = {
      commodityId: obj._id,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.loanAppsLoaded = false;
    this.lservice.RepaymentbyCommodityWhr(obj).subscribe((data) => {
      this.dataRec = true;
      this.loanAppsLoaded = true;
      if (data['success']) {
        this.whrData = data['data'];
        // this.ngxLoader.stop();
      }
    });
  }

  loanData(obj) {
    // this.ngxLoader.start();
    this.loanAppsLoaded = true;
    this.cmdShow = false;
    this.whrShow = false;
    this.loanShow = true;
    let json = {
      wId: obj._id[0],
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.loanAppsLoaded = false;
    this.lservice.RepaymentbyWhrLoans(json).subscribe((data) => {
      this.dataRec = true;
      this.loanAppsLoaded = true;
      if (data['success']) {
        this.loanDataToShow = data['data'];
        // this.ngxLoader.stop();
      }
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  removeFilter() {
    this.isFilterSet = false;
    this.fromDate = null;
    this.toDate = null;

    this.getRepaymentByCommodity();
  }

  filterByDate() {
    if (!this.fromDate || !this.toDate) return;

    this.isFilterSet = true;

    const query = {
      fromDate: this.fromDate,
      toDate: this.toDate,
    };

    this.getRepaymentByCommodity(query);
  }
}
